import { render, staticRenderFns } from "./IndexBanner.vue?vue&type=template&id=b5d308f4&scoped=true&"
import script from "./IndexBanner.vue?vue&type=script&lang=js&"
export * from "./IndexBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d308f4",
  null
  
)

export default component.exports